import { Box, Flex, Text, Image } from "@chakra-ui/react";
// import User from "./User";

// Add optional face prop
type TestimonialProps = {
    children: React.ReactNode,
    name: string,
    company: string,
    _href: string,
    face?: string // PNG face image path or URL
}

// Default face image
const DEFAULT_FACE = require("../assets/icon.png");

export const Testimonial = ({ children, name, company, _href, face }: TestimonialProps): JSX.Element => {
    return (
        <Box
            overflow="hidden"
            p={6}
            width="100%"  // Remove fixed width, let grid control it
            backgroundColor="purple.900"
            borderRadius="16px"
            borderColor="purple.300"
            borderWidth={1}
            boxShadow="0 4px 12px rgba(0, 0, 0, 0.2)"
            transition="transform 0.3s, box-shadow 0.3s"
            _hover={{
                transform: "translateY(-5px)",
                boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)"
            }}
        >
            <Flex width="100%" mb={4} alignItems="center">
                <Image
                    src={face || DEFAULT_FACE}
                    alt={name + "'s face"}
                    boxSize="64px"  // Increased from 48px to 64px
                    borderRadius="full"
                    mr={4}
                    fallbackSrc={DEFAULT_FACE}
                />
                <Box flexGrow={1} textAlign="left" pl={0}>
                    <Text fontWeight="bold">{name}</Text>
                    <Text color="white" fontSize="sm">{company}</Text>
                </Box>
            </Flex>
            <Text fontSize="md" textAlign="left" lineHeight="1.6">
                {children}
            </Text>
        </Box>
    );
}
